const DOM = {};

const cacheDOM = () => {
    DOM.embeddedVideo = document.querySelectorAll('.video-embed__wrapper');
};

const createVideo = (videoId) => {
    const videoframe = document.createElement('iframe');
    videoframe.setAttribute(
        'src',
        `https://www.youtube.com/embed/${videoId}?autoplay=1`
    );
    videoframe.setAttribute('allowfullscreen', '');
    videoframe.classList.add('video-embed__videoframe');

    return videoframe;
};

const swapToVideo = (videoWrapper) => {
    const thumbnail = videoWrapper.firstElementChild;
    const videoId = thumbnail.dataset.videoid;
    const videoframe = createVideo(videoId);

    thumbnail.nextElementSibling.remove();
    thumbnail.parentElement.appendChild(videoframe);
    thumbnail.remove();
};

const handleSwap = (e) => {
    swapToVideo(e.target.parentElement);
};

const bindEvents = () => {
    DOM.embeddedVideo.forEach((element) => {
        element.addEventListener('click', handleSwap);
    });
};

const init = () => {
    cacheDOM();
    if (DOM.embeddedVideo) {
        bindEvents();
    }
};

const embeddedVideo = { init };
export default embeddedVideo;
